import { fetcher } from "helpers/fetcher";

import { TGetStaffMatchingReq, TGetStaffMatchingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffMatching = async (payload?: TGetStaffMatchingReq) => {
  return await fetcher<TGetStaffMatchingRes, TGetStaffMatchingReq["data"]>(
    ENDPOINT.BU.GET_STAFF_MATCHING,
    {
      data: payload?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_STAFF_MATCHING.version,
        [API_HEADER.BU_ID]: payload?.idBu,
      },
    }
  );
};

export const queryGetStaffMatching = async (params?: TGetStaffMatchingReq) => {
  return (await getStaffMatching(params)).data;
};

queryGetStaffMatching._key = (params?: TGetStaffMatchingReq, key?: string) => [
  ENDPOINT.BU.GET_STAFF_MATCHING.url,
  params,
  key,
];
